import React, { useState } from "react";
import { Box, Grid, Typography, Button } from "@mui/material";

const ManagerPocketMoneyRecord = ({ selectedTask }) => {
  const [selectedDay, setSelectedDay] = useState("Mon");

  const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const expenses = [
    { description: "For Snacks and Cool Drinks", amount: 25 },
    { description: "For Travel to School", amount: 8 },
    { description: "For Musical fest", amount: 25 },
  ];
  const weeklyStartingBalance = 65;
  const pocketMoneyAllowance = 125;

  function getWeekOfMonth(dateString) {
    const date = new Date(dateString);
    const startOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
    const dayOfWeek = startOfMonth.getDay(); // Day of the week for the 1st of the month
    const adjustedDate = date.getDate() + dayOfWeek;
    return Math.ceil(adjustedDate / 7); // Calculate week number
  }

  return (
    <Box mt={5}>
      <Typography sx={{ fontSize: "14px", mb: 2, color: "black" }}>Week {getWeekOfMonth(selectedTask.date)}</Typography>
      {/* Days Selector */}
      <Grid container spacing={1} sx={{ mb: 2 }}>
        {days.map((day) => (
          <Grid item key={day}>
            <Button
              variant={day === selectedDay ? "contained" : "outlined"}
              color={day === selectedDay ? "primary" : "inherit"}
              onClick={() => setSelectedDay(day)}
            >
              {day}
            </Button>
          </Grid>
        ))}
      </Grid>

      {/* Expenses */}
      <Box mb={3}>
        {expenses.map((expense, index) => (
          <Grid container justifyContent='space-between' key={index} sx={{ mb: 1 }}>
            <Typography variant='body2'>{expense.description}</Typography>
            <Typography variant='body2'>${expense.amount.toFixed(2)}</Typography>
          </Grid>
        ))}
        <Grid container justifyContent='space-between' sx={{ mt: 1 }}>
          <Typography variant='body2' sx={{ fontWeight: "bold", color: "blue" }}>
            Total
          </Typography>
          <Typography variant='body2' sx={{ fontWeight: "bold", color: "blue" }}>
            ${expenses.reduce((sum, expense) => sum + expense.amount, 0).toFixed(2)}
          </Typography>
        </Grid>
      </Box>

      {/* Summary */}
      <>
        <Grid container justifyContent='space-between' sx={{ mb: 1 }}>
          <Typography variant='body2'>Weekly Starting Balance</Typography>
          <Typography variant='body2'>${weeklyStartingBalance.toFixed(2)}</Typography>
        </Grid>
        <Grid container justifyContent='space-between' sx={{ mb: 1 }}>
          <Typography variant='body2'>Pocket Money Allowance</Typography>
          <Typography variant='body2'>${pocketMoneyAllowance.toFixed(2)}</Typography>
        </Grid>
        <Grid container justifyContent='space-between' sx={{ mt: 1 }}>
          <Typography variant='body2' sx={{ fontWeight: "bold", color: "blue" }}>
            Current Balance
          </Typography>
          <Typography variant='body2' sx={{ fontWeight: "bold", color: "blue" }}>
            ${selectedTask.balance}
          </Typography>
        </Grid>
      </>
    </Box>
  );
};

export default ManagerPocketMoneyRecord;
